import { useNotifications } from '@/hooks/useNotifications';
import { Box } from '@mui/material';
import { NotificationItem } from './NotificationItem';

export const NotificationStack = () => {
  const { notifications } = useNotifications();

  if (!notifications.length) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        pointerEvents: 'none',
      }}
    >
      {notifications.map(notification => (
        <Box key={notification.id} sx={{ pointerEvents: 'auto' }}>
          <NotificationItem notification={notification} />
        </Box>
      ))}
    </Box>
  );
};
